import React, { useState, useContext } from 'react';
import OtpInput from 'react-otp-input';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../interfaces/api';
import  './ConfirmTransactionPinCod.scss';
import BillsInfoContext from '../../context/BillsInfoContext/BillsInfoContext';
import { USER } from '../../interfaces/auth.interface';
import { BeatLoader, Spinner } from '../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const ConfirmTransactionPinCod: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    user,
    verifypin,
    verifypinState,
    withdrawCod,
    withdrawCodState,
    resetApi
 }) => {

    const [otp,setOtp] = useState('');
    const withdrawDetails = modal?.ownProps?.withdrawData;
    const accountDetails = modal?.ownProps?.accountNo;
    const generateRef =  `TRF-${Math.floor(Math.random() * 1000000000 + 1)}-MWEB`;

    React.useEffect(
      () => () => {
        resetApi(API_KEYS.VERIFY_USER_PIN);
        resetApi(API_KEYS.WITHDRAW_COD);
      },
      [resetApi]
    );

    // console.log('Withdraw details',withdrawDetails);
    
    const handleChange = (code:any) => { setOtp(code) }

    const closeModal = () => {
        hideModal();
      };

    const verifyPin = () => {
        verifypin({CustomerPin : otp});


    }

    React.useEffect(() => {
      if(accountDetails){
        if (verifypinState?.success && verifypinState?.response?.Object) {
          showModal({
            component: 'StellasAccountDetails',
            modalProps: {
            contentLabel: 'Stellas Account Details',
            },
            ownProps: {
              accountNo: accountDetails
            }
          });
        }
      }
    },[verifypinState?.success, verifypinState?.response?.Object, accountDetails])

    React.useEffect(() => {
      if(withdrawDetails){
          if (verifypinState?.success && verifypinState?.response?.Object) {
            withdrawCod({
                receiverAccountNumber : withdrawDetails.AccountNumber,
                receiverbankCode : withdrawDetails.BankName.code,
                retrievalReference : generateRef,
                narration : 'Withdrawal request from COD wallet',
                receiverBankName : withdrawDetails.BankName.name,
                amount : withdrawDetails.Amount
            })
        }
      }
   }, [withdrawDetails, verifypinState?.success && verifypinState?.response?.Object, withdrawCod]);

   React.useEffect(()=> {
     if(!withdrawCodState?.loading && withdrawCodState?.success && withdrawCodState?.response?.Object.status === true){
      hideModal();
      showModal({
        component: 'WithdrawSuccess',
        modalProps: {
          contentLabel: 'Withdraw Success Modal',
        },
        ownProps: {
          amount: withdrawDetails.Amount
        }
      });
     }
   },[!withdrawCodState?.loading, withdrawCodState?.success, withdrawCodState?.response?.Object.status, showModal, hideModal])

    return(
        <div className="w-full px-8 bg-white lg:px-24 py-10 relative">
                         <button type="button" aria-label="Close" onClick={closeModal}>
          <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
        </button>
         <div className="w-full my-2 text-center">
             <h2 className="mb-1 text-2xl font-bold text-black">Confirm Transaction</h2>
          </div>
          <div className="w-full max-w-md mx-auto text-center mb-10 text-sm">
            <p className="text-gray-500 my-4">
            Kindly confirm transaction with wallet pin
           </p>
           <div>
           <OtpInput 
           inputStyle="otp-field"
            value={otp}
            onChange={handleChange}
            numInputs={4}
            isInputSecure={true}
            separator={<span> </span>}
          />
           </div>
          </div>
          <button className="w-full bg-secondary font-medium text-sm rounded text-white py-4" type="button" onClick={() => verifyPin()}
          disabled={verifypinState?.loading}
          >{verifypinState?.loading || withdrawCodState?.loading ? <BeatLoader color="white" /> : 'Confirm Transaction'}
          
          </button>
              {/* {otp.length == 4 && otp !== walletpin ? (<p className="text-red-600 text-center m-2">Pin don't match</p>) : (
              <div className="text-center">
                 <span className="inline-flex items-center">
                      <p className="text-red-600 text-xs"> </p>
                </span>
              </div>
               )} */}
      </div>
      );
    };
    
    export default ConfirmTransactionPinCod;